var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-row",
    [
      _c(
        "w-col",
        { attrs: { xs: "12" } },
        [
          _c("app-contact-search", {
            attrs: { "group-id": _vm.groupId, label: _vm.label, fancy: "" },
            on: {
              input: function ($event) {
                return _vm.onInput($event)
              },
            },
          }),
          _c(
            "w-scroll-view",
            { style: { maxHeight: "150px" }, attrs: { tag: "w-list" } },
            _vm._l(_vm.items, function (item) {
              return _c(
                "w-list-item",
                { key: item.ID },
                [
                  _c(
                    "w-list-item-text",
                    [
                      _vm._v(" " + _vm._s(item.getDisplayName())),
                      _c("w-spacer"),
                      _c(
                        "w-button",
                        {
                          directives: [
                            {
                              name: "tooltip",
                              rawName: "v-tooltip",
                              value: _vm.$ct("remove-item"),
                              expression: "$ct('remove-item')",
                            },
                          ],
                          attrs: { flat: "" },
                          on: {
                            click: function ($event) {
                              return _vm.removeContact(item)
                            },
                          },
                        },
                        [_c("w-fa", { attrs: { icon: "times" } })],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              )
            }),
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }